import * as TYPES from './types';

const initialState = {
  list: [],
  fetching: false,
  errorMessages: null,
  total: 0,
  deliveryNote: null, // <-- Añade este campo
};

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case TYPES.GET_DELIVERY_NOTES_REQUEST:
    case TYPES.GET_DELIVERY_NOTE_REQUEST:
      return { ...state, fetching: true, errorFetching: false };

    case TYPES.GET_DELIVERY_NOTES_ERROR:
    case TYPES.CREATE_ERRORS:
      return {
        ...state,
        errorMessages: payload,
        isCreated: false,
        fetching: false,
      };
    case TYPES.GET_DELIVERY_NOTES_SUCCESS: {
      return {
        ...state,
        total: payload.total,
        list: [...payload.data],
        fetching: false,
      };
    }

    case TYPES.GET_DELIVERY_NOTE_SUCCESS: {
      const updatedList = state.list.map((note) =>
        note.id === payload.id ? payload : note,
      );
      const exists = state.list.some((note) => note.id === payload.id);
      return {
        ...state,
        deliveryNote: payload,
        list: exists ? updatedList : [payload, ...state.list],
        fetching: false,
      };
    }

    case TYPES.UPDATE_DELIVERY_NOTE_SUCCESS: {
      const updatedList = state.list.map((note) =>
        note.id === payload.id ? payload : note,
      );
      return {
        ...state,
        deliveryNote: payload,
        list: updatedList,
        fetching: false,
      };
    }

    case TYPES.GET_DELIVERY_NOTE_ERROR:
    case TYPES.UPDATE_DELIVERY_NOTE_ERROR: {
      return {
        ...state,
        errorMessages: payload,
        fetching: false,
      };
    }

    case TYPES.CLEAR_DELIVERY_NOTES_STATE: {
      return {
        ...state,
        fetching: false,
        errorMessages: null,
        errorMessagesProfile: null,
        isCreated: false,
        createdScannedDocument: {},
      };
    }

    case TYPES.CLEAR_ERRORS: {
      return { ...state, errorMessages: null };
    }

    case TYPES.INIT_REDUCER:
      return {
        ...initialState,
      };

    default:
      return { ...state };
  }
}
